import { TableHeaderCategoryConfig } from "../../../../components/tables/tableContext/TableContext";

const camelToLabel = (key: string): string => {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase())
    .trim();
};

const excludedKeys = ["idUser"];

export const generateUsersExtraActivitiesHeader = (
  data: any[],
): TableHeaderCategoryConfig[] => {
  if (!data?.length) return [];

  const keys = Object.keys(data[0]).filter(
    (key) => !excludedKeys.includes(key),
  );

  return keys.map((key) => ({
    label: camelToLabel(key),
    value: key,
    minW: 125,
  }));
};

export const generateUsersExtraActivitiesTableData = (data: any[]) => {
  if (!data?.length) return [];

  const keys = Object.keys(data[0]).filter(
    (key) => !excludedKeys.includes(key),
  );

  return data.map((item) => ({
    id: item.idUser,
    crudData: item,
    data: keys.map((key) => ({
      title: item[key as keyof any] ?? "-",
    })),
  }));
};
